/* Slider-logik til Tut og håndtegnede ikoner (b2b-media-kit-tut / b2b-media-kit-ikoner) */
(function () {
  function init(root) {
    if (!root || root.dataset.tutInit) return;
    root.dataset.tutInit = '1';

    function rotate(card) {
      var wrapper = card.parentElement;
      if (card.classList.contains('is-exiting')) return;
      var cards = Array.prototype.slice.call(wrapper.querySelectorAll('.tut-card'));
      if (cards.length < 2) return;
      card.classList.add('is-exiting');

      var next = cards[(cards.indexOf(card) + 1) % cards.length];
      next.style.opacity = '1';
      next.style.pointerEvents = 'auto';
      next.style.zIndex = '1';
      card.style.zIndex = '10';

      setTimeout(function () {
        card.classList.remove('is-exiting');
        card.style.opacity = '0';
        card.style.pointerEvents = 'none';
        wrapper.appendChild(card);

        var updated = wrapper.querySelectorAll('.tut-card');
        updated.forEach(function (c, idx) { c.style.zIndex = updated.length - idx; });

        var activeIdx = parseInt(updated[0].getAttribute('data-index'), 10);
        updated[0].querySelectorAll('.tut-dot').forEach(function (dot, i) {
          dot.classList.toggle('active', i === activeIdx);
        });
      }, 600);
    }

    // I tema-editoren: vælges et kort i venstre menu, vises det øverst i sliderens stak.
    function showCard(card) {
      var wrapper = card.parentElement;
      var cards = Array.prototype.slice.call(wrapper.querySelectorAll('.tut-card'));
      var idx = cards.indexOf(card);
      if (idx < 1) return;
      cards.slice(0, idx).forEach(function (c) { wrapper.appendChild(c); });
      var updated = wrapper.querySelectorAll('.tut-card');
      updated.forEach(function (c, i) {
        c.classList.remove('is-exiting');
        c.style.zIndex = updated.length - i;
        c.style.opacity = i === 0 ? '1' : '0';
        c.style.pointerEvents = i === 0 ? 'auto' : 'none';
      });
      var activeIdx = parseInt(updated[0].getAttribute('data-index'), 10);
      updated[0].querySelectorAll('.tut-dot').forEach(function (dot, i) {
        dot.classList.toggle('active', i === activeIdx);
      });
    }

    document.addEventListener('shopify:block:select', function (e) {
      var card = e.target;
      if (card && card.classList && card.classList.contains('tut-card') && root.contains(card)) showCard(card);
    });

    root.addEventListener('click', function (e) {
      var card = e.target.closest('.tut-card');
      if (card && root.contains(card)) rotate(card);
    });

    root.querySelectorAll('[data-tut-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!btn.classList.contains('is-loading')) {
          btn.classList.add('is-loading');
          setTimeout(function () { btn.classList.remove('is-loading'); }, 2500);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.tut-stack-section').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
